import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { SubmitReviewComponent } from '@app-modules/feature/dashboard/component/exam-page/submit-review/submit-review.component';
import { LoginService } from '@app-services/login/login.service';
import { UserService } from '@app-services/user/user.service';
import { LocalStorageService } from 'ngx-webstorage';
import { ExamService } from '@app-services/test/exam.service';
import { SubmitConfirmationComponent } from '../../../feature/dashboard/component/exam-page/submit-confirmation/submit-confirmation.component';
import { AuthService } from '@app-services/auth-service/auth.service';
import { TestlistService } from '@app-services/test/testlist.service';
import * as moment from 'moment';

import { TenantConstant } from '@app-constants/tenant.constant';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { Subscription } from 'rxjs';
import { EventHandlingService } from 'src/app/core/services/event-handling.service';
import { ConfirmEditPhoneNumberDialogComponent as ConfirmtaionDialogComponent } from '@app-shared/components/confirm-edit-phone-number-dialog/confirm-edit-phone-number-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';

import { allowedExamNamesCT, apisDataCacheKeys, avatarImagesPath, callUssupportNumber, dashboardRoute, examDisplayNames, focusExamURL, homeRoute, timeBoundTypes } from '@app-constants/app.constants';
import { clearLocalStorage, getMomentUTCtime, isUserAdmin, navigateBetweenProjects, setILCookie } from 'src/app/helpers/functions';
import { openAdmissionLoginForm, openLoginForm } from 'src/app/helpers/methods';
import { FocusExamComponent } from '@app-modules/feature/dashboard/component/new-dashboard/dialogs/focus-exam/focus-exam.component';
import { TaskTimer } from 'tasktimer';
import { indexOf } from 'lodash-es';
import { Location } from '@angular/common';
import { MyactivityService } from 'src/app/core/services/myactivity.service';
import { ChatService } from '@app-core/chatwindow/chat.service';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { ClassService } from 'src/app/core/services/class.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NavigationService } from 'src/app/core/services/navigation.service';

declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  submitFeedbackPopsubscription: Subscription;
  @ViewChild('timerTickerDisplay') timerTickerDisplay: ElementRef;

  ngAfterViewInit() {
    //Hamburger Menu
    $('.without-exam .hamburger-menu').click(function () {
      //alert('click');
      $('header').addClass('menu-expend');
      //$('body').addClass('no-scroll');
    });
    $('.without-exam .logo-right .m-overlay').click(function () {
      $('header').removeClass('menu-expend');
      //$('body').removeClass('no-scroll');
    });
    $('.without-exam .logo-right .mh-link').click(function () {
      $('header').removeClass('menu-expend');
      //$('body').removeClass('no-scroll');
    });
  }

  eventSubscriber: Subscription = null;
  examServiceTestegning$: Subscription = null;
  examInfo_setting$: Subscription = null
  examInfo: any = {};
  timer_ticker: any = '';
  timeInterval: any = null;
  counter: any = 1;
  token: any;
  isAuthenticated: any;
  profilePhoto: any;
  user: any;
  is_exam_started: boolean = false;
  current_route_url = '';
  disableForYtVideosMweb: boolean = false;
  timer_header_for_routes = ['/dashboard/exampage', '/dashboard/testinstructions', '/dashboard/question-list'];
  timerWarning: boolean = false;
  submitRequestMade: boolean = false;
  subscriptionHeader: boolean = false;
  tenant: any = TenantConstant.tenant;
  portal = TenantConstant.portal;
  openAdmissionLoginForm = openAdmissionLoginForm;
  openLoginForm = openLoginForm;
  getMomentUTCtime= getMomentUTCtime;
  profilePic: boolean = false;
  profileImagePath = avatarImagesPath;
  examName = "";
  displayExamName: any;
  selectedExam: any;
  displayGrade: string;
  currentUserDetails: any;
  myExamId: any;
  examNameForId: string;
  showCopyOption = false
  //logo tooltip variable
  logotooltipstatus: boolean = false;
  allBadgeDetails: any;
  isScratchPopupDisplayed = false;

  focusExamDopdown: boolean = false;
  isTimeUp: boolean = false;
  public deviceWidth;
  public mobileWidth: boolean = false;
  constructor(
    private dialog: MatDialog,
    private examService: ExamService,
    private storage: LocalStorageService,
    public router: Router,
    private authService: AuthService,
    private userService: UserService,
    private loginService: LoginService,
    private testListService: TestlistService,
    private gaService: GAnalyticsService,
    private spinner: NgxSpinnerService,
    private eventHandlingService: EventHandlingService,
    private location: Location,
    private AchievementsService: MyactivityService,
    private chatService: ChatService,
    private _inviteService: InviteEarnService,
    private deviceService: DeviceDetectorService,

    private classService: ClassService,
    private navigationService: NavigationService,
  ) {
    this.token = localStorage.getItem('token')
    if (this.token) {
      this.isAuthenticated = true;
      this.loadUser();
    }
    this.userService.setGoalsObserable.subscribe((timing) => {
      if (timing) {
        this.updategoalDetails(false);
      }
    })

    // window.addEventListener('storage', (details:any) => {
    //   const {key, newValue, storageArea} = details;
    //   if(storageArea == localStorage && ((key == 'token' || key == apisDataCacheKeys.userDetails && newValue == null) || !localStorage.getItem('token') || !localStorage.getItem(apisDataCacheKeys.userDetails))) {
    //     this.logoutPrestep();
    //   }
    // });

    this.loginService.logoutEvent.subscribe((popupMessages) => {
      this.logoutPrestep(popupMessages);
    });

    this.authService.isAuth.subscribe(isAuth => {
      this.isAuthenticated = isAuth;
      //
      if (this.isAuthenticated) {
        this.loadUser();
      }
    });

    this.authService.photo.subscribe(pic => {
      if (pic) {
        this.profilePic = false;
        this.profilePhoto = pic
      } else {
        this.profilePic = true;
      }
    });
    // this.profilePhoto = this.authService.photo.subscribe(pic => this.profilePhoto = pic);
    //this.profilePhoto = this.userService.getUserProfileImg();
    this.examInfo_setting$ = this.examService.getExamInfo.subscribe((examinfo: any) => {
      this.examInfo = examinfo;
      if (this.examInfo?.examtype == "SCOREAWAT") {
        let serverTime = localStorage.getItem('serverTime');
        this.examInfo.span = this.examInfo?.examStartedOn || this.examInfo?.examStartTime || moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss A");
      }
    })

    this.examServiceTestegning$ = this.examService.testBegins.subscribe((begins: any) => {
      this.submitRequestMade = false;
      this.initInterval();
    });

    this.examService.testFinish.subscribe((successFul: any) => {
      if (successFul) {
        if (this.timeInterval) {
          this.closeinterval();
        }
        let examcountdown = this.storage.retrieve('examcountdown');
        if (examcountdown) {
          this.storage.clear('examcountdown');
        }
        let exam_meta_data: any = localStorage.getItem('exam_meta_data');
        if (exam_meta_data) {
          localStorage.removeItem('exam_meta_data');
        }
      }
      this.submitRequestMade = false;
    });
    this.is_exam_started = false;
    let exam_meta_data: any = localStorage.getItem('exam_meta_data');
    if (exam_meta_data) {
      this.examService.updatedExamMetaDataSource(JSON.parse(exam_meta_data));
    }

    this.examService.examMetaData.subscribe((data) => {
      //
      if (data && data.submitted == false && data.started && data.started == true) {
        this.is_exam_started = true;
      } else {
        this.is_exam_started = false;
      }
    });
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const isMobile = this.deviceService.isMobile();
        this.current_route_url = event.url;
        this.disableForYtVideosMweb = (event.url == '/selfLearn-V2/ytVideos' && isMobile == true) ? true : false;
        let examName: any = localStorage.getItem('targetExamName');
        this.displayExamName = examDisplayNames[examName];
        this.subscriptionHeader = false;
        //if user tried to visit exam page/question list page without starting the exam. redirect to dashboard
        if (['/dashboard/exampage', '/dashboard/question-list'].includes(this.current_route_url) && this.is_exam_started == false) {
          this.router.navigateByUrl('/dashboard');
        }

        let examinfofromstore = this.examService.getPresentExamInfo();
        if (examinfofromstore && ['/dashboard/exampage', '/dashboard/question-list', '/dashboard/testinstructions'].includes(this.current_route_url)) {

          this.examInfo = examinfofromstore;
          let examcountdown = this.storage.retrieve('examcountdown');
          let exam_meta_data: any = localStorage.getItem('exam_meta_data');
          if (examcountdown && exam_meta_data && JSON.parse(exam_meta_data)?.submitted == false) {
            if (!this.timeInterval) {
              this.remainingTimeCalculator();
            }
          }
        }
        if (this.current_route_url.indexOf('subscription') !== -1) {
          this.subscriptionHeader = true;
        }
        if (this.current_route_url.indexOf('coming-soon') !== -1) {
          this.isAuthenticated = localStorage.getItem('token') ? true : false;
          if (!this.isAuthenticated) {
            this.router.navigate(['']);
          }
        }
        if (focusExamURL.includes(this.current_route_url)) {
          this.focusExamDopdown = true;
        } else {
          this.focusExamDopdown = false;
        }
        //  if (['/subscription/mycart'].includes(this.current_route_url)) {
        localStorage.removeItem('logo-popup');
        //  }
        if (this.current_route_url == '/dashboard' && localStorage.getItem('stay-clicked')) {
          localStorage.removeItem('stay-clicked');
          window.location.reload();
          localStorage.setItem('page-reload-done', 'true');
        }
      }
    });
    if (window.performance.navigation && window.performance.navigation.type === 1 && localStorage.getItem('page-reload-done')) {
      localStorage.removeItem('page-reload-done');
      let preurl = JSON.parse(localStorage.getItem('current-subscr-url'));
      this.router.navigate([preurl]);
    }

    this.submitFeedbackPopsubscription = this.examService.submitFeedbackPopupSubject$.subscribe((value) => {
      if (value) {
        this.reviewSubmit()
      }
    })
  }

  logoutPrestep(popupMessages?: any) {
    this.spinner?.hide && this.spinner?.hide();
    if (popupMessages?.showPopup) {
      const config: MatDialogConfig = {
        width: '487px',
        height: '292px',
        data: { message: popupMessages?.message || 'Session expired!!!', message2: popupMessages?.message2 || `Please login again to continue.` }
      };
      const dialogRef = this.dialog.open(ConfirmtaionDialogComponent, config);
      dialogRef.afterClosed().subscribe((value) => {
        this.logout('sessionend');
      });
    }
    else {
      this.logout('sessionend');
    }
  }
  @HostListener('contextmenu', ['$event'])
  onRightClick(event: any) {
    if (['/dashboard/exampage', '/dashboard/question-list', '/dashboard/testinstructions'].includes(this.current_route_url)) {
      event.preventDefault();
    }
  }
  ngOnInit(): void {
    this.eventSubscriber = this.eventHandlingService.getChangeAction().subscribe(
      (item: any) => {
        if (item && item?.type == "updateProPic") {
          this.profilePhoto = this.userService.getUserProfileImg();
          if (this.profilePhoto) {
            this.profilePic = false;
          } else {
            this.profilePic = true;
          }
        }
      });
    this.examNameForId = localStorage.getItem('targetExamName');
    this.currentUserDetails = JSON.parse(localStorage.getItem('user_details_from_server'));
    // this.myExamId = this.currentUserDetails ? this.currentUserDetails.exams.find(el => el.name?.replaceAll(' ', '')?.toUpperCase() == this.examNameForId)?.examId : null;


    document.addEventListener('visibilitychange', (e: any) => {

      if (document.hidden) {

        //window.location.href="/dashboard"
        // tab is now inactive
        // temporarily clear timer using clearInterval() / clearTimeout()
      }
      else {
        if (['/dashboard/exampage', '/dashboard/question-list', '/dashboard/testinstructions'].includes(this.current_route_url)) {
          //this.userActivateTheTabAgain()
        }
      }
    });
    this.eventHandlingService.showLogoPopup.subscribe(res => {
      if (res) {
        this.logotooltip('stay')
      }
    })

    // if (this.currentUserDetails) {
    //   this.AchievementsService.getAllBadgeSummary();
    // }


    this.AchievementsService.badgeInvokeSubject.subscribe(res => {
      console.log("res Subject", res);
      // this.myExamId = res.myExamId;
      this.examNameForId = localStorage.getItem('targetExamName');
      this.currentUserDetails = JSON.parse(localStorage.getItem('user_details_from_server'));
      // this.myExamId = this.currentUserDetails ? this.currentUserDetails.exams.find(el => el.name?.replaceAll(' ', '')?.toUpperCase() == this.examNameForId)?.examId : null;
      // if (this.currentUserDetails) {
      //   this.getAllBadgeSummary();
      // }
    });
    // this.getSelfLearnBadges()
    this.examService.autoSubmitExam = false;
  }




  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.deviceWidth = window.innerWidth;
    if (this.deviceWidth <= 768) { //? for phone icon
      this.mobileWidth = true
    } else {
      this.mobileWidth = false;
    }
    //? added this.isAuthenticated otherwise its getting called whenever we resize even when we are not loggedin, that creating login issue In mWeb
    if (this.deviceWidth <= 768 && this.isAuthenticated) {
      this.loadUser();
    }

  };

  @HostListener('window:load', ['$event'])
  onPageLoad(event: Event) {
    this.deviceWidth = window.innerWidth;
    if (this.deviceWidth <= 768) { //? for phone icon
      this.mobileWidth = true
    } else {
      this.mobileWidth = false;
    }
  }
  loadUser(): void {
    this.userService.loadUserDetails().subscribe((data) => {
      this.user = data;
      this.AchievementsService.getUserProfileDetailsSubject.next(data);
      this.profilePhoto = data.profilePhoto
      if (this.profilePhoto) {
        this.profilePic = false;
      } else {
        this.profilePic = true;
      }

      if (localStorage.getItem('targetExamName')) {
        let examName: any = localStorage.getItem('targetExamName');
        this.displayExamName = examDisplayNames[examName];
        this.examName = examName;
        this.displayGrade = `Grade ` + this.user?.grade?.name.replace('th', '');
        // this.eventHandlingService.changeFocusedExamFromHeader.next({examName: this.displayExamName})
      } else {
        this.displayExamName = this.user?.selectedExams[0]?.name || this.user?.exams[0]?.name;
        let examName: any = this.user?.selectedExams[0]?.name?.replaceAll(' ', '')?.toUpperCase() || this.user?.exams[0]?.name?.replaceAll(' ', '')?.toUpperCase();
        this.examName = examName;
        localStorage.setItem('targetExamName', examName);
        localStorage.setItem("selectedExam", JSON.stringify(this.user?.exams[0]))
        this.displayGrade = `Grade ` + this.user?.grade?.name.replace('th', '');
        // this.eventHandlingService.changeFocusedExamFromHeader.next({examName: this.displayExamName})
      }
    });
  }

  async remainingTimeCalculator() {
    this.closeinterval();
    this.counter = this.storage.retrieve('examcountdown');
    let timeSpendonQuestions = this.storage.retrieve('quesResponses')?.map(v => (v?.responses || v?.questions))?.flat()?.filter(v => v)?.map(v => v.visitedtime).filter(v => v)?.reduce((a, c) => a + Number(c), 0);
    if (timeBoundTypes.indexOf(this.examInfo.examtype) != -1) {

      // let servertimeAPi = await this.testListService.getServerTime();
      localStorage.setItem('serverTime',this.getMomentUTCtime())
      // moment(servertime).utc().unix()
      let serverTime = localStorage.getItem('serverTime') + '000';
      let serverTimeNow = moment(+serverTime);
      var examStartTime = moment(this.examInfo.span, 'YYYY-MM-DD hh:mm A')
      this.counter = +this.examInfo.duration - serverTimeNow.diff(examStartTime, 'minutes')
      this.timeUpAutoSubmit()
      this.countDownTimerObserable()
    } else {
      this.counter = Number(this.examInfo.duration) - ((timeSpendonQuestions) / 60);
      console.log(this.counter, this.examInfo.duration, timeSpendonQuestions)
      if (!this.counter) {
        this.counter = Number(this.examInfo.duration);
      } else {
        this.timeUpAutoSubmit()
      }
      this.countDownTimerObserable()
    }
  }
  countDownTimerObserable() {
    var time_in_seconds = parseFloat(this.counter) * 60;
    if (time_in_seconds > 0) {
      this.timer_ticker = new Date(time_in_seconds * 1000).toISOString().substr(11, 8);
      if(this.timerTickerDisplay?.nativeElement) {
        this.timerTickerDisplay.nativeElement.innerText = this.timer_ticker;
      }
    }
    this.timeInterval = new TaskTimer(1000);
    this.timeInterval.add(task => {
      if (this.isTimeUp == false) {
        time_in_seconds--
        // if(!this.timerTickerDisplay && this.showPage != "instructions" && this.navigationService.previousUrl) {
        // if(!this.timerTickerDisplay) {
        //   window.location.reload();
        // }
        this.storage.store('examcountdown', time_in_seconds / 60);

        if (time_in_seconds < 301) {
          this.timerWarning = true;
        } else {
          this.timerWarning = false;
        }
        if (time_in_seconds > 0) {
          this.timer_ticker = new Date(time_in_seconds * 1000).toISOString().substr(11, 8);
          if(this.timerTickerDisplay?.nativeElement) {
            this.timerTickerDisplay.nativeElement.innerText = this.timer_ticker;
          } 
        } else {
          if (time_in_seconds == 0 || time_in_seconds <0) {
            this.isTimeUp = true;
            this.closeinterval();
            if (timeBoundTypes.indexOf(this.examInfo.examtype) > -1) {
              this.examService.autoSubmitExam = true;
              this.submitTest();
            } else {
              if(this.examInfo?.isLCAssignment) {
          
              } else {
                this.reviewSubmit();
              }
            }
          }
        }
      }
    }).start();
  }
  timeUpAutoSubmit() {
    if (this.counter == 0 || this.counter < 0) {
      this.isTimeUp = true;
      this.closeinterval();
      if (timeBoundTypes.indexOf(this.examInfo.examtype) > -1) {
        this.examService.autoSubmitExam = true;
        this.submitTest();
      } else {
        if(this.examInfo?.isLCAssignment) {

        } else {
          this.reviewSubmit();
        }
      }
      return;
    }
  }

  closeinterval() {
    if (this.timeInterval) {
      this.timeInterval.stop();
      this.timeInterval = null;
    }
  }


  reviewSubmit() {
    this.dialog.closeAll();
    const config: MatDialogConfig = {
      panelClass: 'UNFAPP-mweb-btmstiky-modal',
      width: '487px',
      // height: '226px',
      data: { message: 'Are you sure you want to submit?' }
    };
    if (!this.isTimeUp || timeBoundTypes.indexOf(this.examInfo.examtype) == -1) {
      const dialogRef = this.dialog.open(SubmitReviewComponent, config);
      dialogRef.afterClosed().subscribe(result => {
        if (result === 'submitted') {
          this.saveRewardCoins();
          this.submitTest()
        } else {
          this.saveRewardCoins();
          this.submitTest()
        }
      });
    } else {
      const dialogRef = this.dialog.open(SubmitReviewComponent, config);
      dialogRef.afterClosed().subscribe(result => {
        console.log('update FeedBack')
        let user = JSON?.parse(localStorage?.getItem(apisDataCacheKeys?.userDetails));
        let examreview = this.storage.retrieve('examreview') || {
          "testtype": "",
          "difficultylevel": [],
          "feedback": "",
          "experience": ""
        };
        var body = {
          "phone": user?.phone,
          "studentid": user?.phone,
          "ruleid": this.examInfo?._id,
          "testreview": examreview
        }
        this.examService.updatefeedback(body).subscribe((resp: any) => {
          let type: string = this.examInfo?.isLCAssignment ? 'assignment' : 'chapter';
          let reportLink = this.examInfo?.isLCAssignment || this.examInfo?.examtype == 'CHAPTERTESTS' ? `/mycourse/${this.examInfo?.courseId}/test-report?type=${type}` : this.examInfo?.examtype == "subjectivemocktest" ? '/dashboard/viewsolutionspage' : '/dashboard/viewtestreport';
          window.location.href = window.location.origin + (this.portal != 'SCORE' || this.examInfo.examtype != 'TIMEBOUND' ? reportLink : `/dashboard/testlist?examname=${(this.examInfo.coursetype || "").replaceAll(" ", "").toUpperCase()}&examtype=${this.examInfo.examtype}`);
        }, (err) => {
          this.router.navigateByUrl('/dashboard/assessment')

        })
      });
    }

  }

  confirmingSubmit() {
    //this.pauseTimer();
    const config: MatDialogConfig = {
      panelClass: 'UNFAPP-mweb-btmstiky-modal',
      width: '487px',
      // height: '226px',
      data: { message: 'Are you sure you want to submit?' }
    };
    const dialogRef = this.dialog.open(SubmitConfirmationComponent, config);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'finish') {
        this.reviewSubmit();
      } else {
        //this.resumeTimer();
      }
    });
  }

  pauseTimer() {
    this.closeinterval();
  }

  resumeTimer() {
    this.counter = this.storage.retrieve('examcountdown');
    if (!this.counter) {
      this.counter = Number(this.examInfo.duration);
    }

    var time_in_seconds = parseFloat(this.counter) * 60;
    this.timer_ticker = new Date(time_in_seconds * 1000).toISOString().substr(11, 8)

    this.timeInterval = new TaskTimer(1000);
    this.timeInterval.add(task => {
      time_in_seconds--
      this.storage.store('examcountdown', time_in_seconds / 60);
      this.timer_ticker = new Date(time_in_seconds * 1000).toISOString().substr(11, 8);
      if (time_in_seconds < 6) {
        this.timerWarning = true;
      } else {
        this.timerWarning = false;
      }
      if (time_in_seconds === 0) {
        this.closeinterval();
        this.reviewSubmit();
      }
    }).start();
  }

  submitTest() {
    this.closeinterval();
    this.submitRequestMade = true;
    this.examInfo.isexamstarted = false;
    this.examService.triggerSubmitExam();
  }

  showMyProfile(): void {
    localStorage.removeItem('logo-popup');
    this.router.navigate(['myprofile']);
  }

 async logout(logoutType?: string) {
    // this.addDailyGoal();
    //web Events
    //?checking user admin or not
   await isUserAdmin(this.userService).then((bool) => {
      if(bool) {
        this.classService.unSyncStudent()
        .toPromise()
        .then((e)=>{
          let user = JSON?.parse(localStorage?.getItem(apisDataCacheKeys?.userDetails));
          this.gaService.webEngageEvent({
            'event': 'Log Out',
            'Phone': user?.phone,
          });
          let spentTime = JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0;
          if (logoutType == 'sessionend') {
            this.sessionNotSession();
          } else {
            if (spentTime > 0) {
              this.updategoalDetails(true);
            } else {
              this.sessionNotSession();
            }
          }
          console.log(this.user,"logged out")
          this.chatService.setUserStatus(this.user?.userId,{isOnline:false,name:this.user?.firstName,lastSeen:new Date().getTime()})

        })
        .catch((err)=>{
        });
        // console.log('admin');
      }else{
        let user = JSON?.parse(localStorage?.getItem(apisDataCacheKeys?.userDetails));
        this.gaService.webEngageEvent({
          'event': 'Log Out',
          'Phone': user?.phone,
        });
        let spentTime = JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0;
        if (logoutType == 'sessionend') {
          this.sessionNotSession();
        } else {
          if (spentTime > 0) {
            this.updategoalDetails(true);
          } else {
            this.sessionNotSession();
          }
        }
        console.log(this.user,"logged out")
        this.chatService.setUserStatus(this.user?.userId,{isOnline:false,name:this.user?.firstName,lastSeen:new Date().getTime()})

      };
    })

   }

  sessionNotSession() {
    const logoutMethod: any = this.tenant == 'srichaitanya' ? this.loginService.logoutSriChaitanya() : this.loginService.logout();
    logoutMethod.subscribe((res: any) => {
    }, (err: any) => {
    });
    let user = JSON.parse(localStorage.getItem(apisDataCacheKeys.userDetails));
    if (user) {
      this.gaService.sendEvent(
        'User Logout',
        '',
        '',
        '',
        {
          'event': 'User Logout',
          'Phone Number': user.phone,
          'First Name': user.firstName,
          'Last Name': user.lastName,
          'City': 'Pune',
          'Email ID': user.email,
          'Session Time': '1 hour',
        }

      );
    }
    this.testListService.clearApisData();
    this.closeinterval();
    clearLocalStorage();
    setILCookie('INFINITY_LEARN', '', -1);
    this.authService.updateAuthStatus(false);
    this.spinner.show();
    window.location.href = homeRoute;
  }

  setDefaultPic() {
    // this.profilePhoto = "assets/img/empty-profile.svg";
    this.profilePic = false;
  }

  goToInstructionPage() {
    this.router.navigateByUrl('/dashboard/testinstructions?isFromExamHeader=true');
  }
  
  goToQList() {
    this.router.navigateByUrl('/dashboard/question-list');
  }

  testStartTime(test: any) {
    let string = test.span;
    let examstart = moment(string, "YYYY-MM-DD hh:mm A").format("YYYY-MM-DD HH:mm:ss");
    return examstart
  }

  userActivateTheTabAgain() {

    if (this.examInfo) {
      this.initInterval();
    }
  }

  initInterval() {
    if (this.timeInterval) {
      this.closeinterval();
    }
    console.log(this.examInfo)
    if (timeBoundTypes.indexOf(this.examInfo.examtype) > -1) {
      //find the total seconds between exam start time and current time;
      let testStartTime = this.testStartTime(this.examInfo);
      let serverTime = localStorage.getItem('serverTime') + '000';
      let serverTimeNow = Number(serverTime);
      var secondBetweenTwoDate = Math.abs((serverTimeNow - new Date(testStartTime).getTime()) / 1000);

      let secondsAvailable = (parseInt(this.examInfo.duration) * 60) - Math.floor(secondBetweenTwoDate);
      let minAvailable = secondsAvailable / 60;
      this.storage.store('examcountdown', minAvailable);

      this.remainingTimeCalculator();
    } else {

      let examInfo = this.examInfo;
      /* checking if data are present in redis cache*/
      let body = {
        scheduleid: examInfo.scheduleid,
        ruleid: examInfo._id,
        studentid: localStorage.getItem('studentid')
      };
      this.testListService.getUserTestResponseData(body).subscribe((testResponseData: any) => {
        if (testResponseData && testResponseData.length) {
          let startTimeStamp = testResponseData[0].startExamTimeStamp;

          let examendDateTime = moment(startTimeStamp, 'YYYY-MM-DD HH:mm:ss').add(parseInt(this.examInfo.duration), 'minutes').format('YYYY-MM-DD HH:mm:ss');
          let serverTime = localStorage.getItem('serverTime');
          let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");
          if (moment(current_time).isAfter(examendDateTime)) {
            //exam duration is over so giving 10 seconds to the user to submit data
            //giving 10 seconds to the user to submit the test if his time is over
            let totalVisitedTime = testResponseData?.data?.reduce((totalVisitedTime: any, testResponse: any) => {
              if (testResponse.timeSpentOnQuestion) {
                return totalVisitedTime + parseInt(testResponse.timeSpentOnQuestion)
              } else {
                return totalVisitedTime + 0
              }
            }, 0);

            let secondsAvailable = this.examInfo.duration * 60 - totalVisitedTime;
            if (secondsAvailable > 0) {
              let minAvailable = secondsAvailable / 60;
              this.storage.store('examcountdown', minAvailable);
            } else {
              //if any home total seconds taken greater than seconds available fot the the test  then give 5 seconds to submit the test
              let minAvailable = 5 / 60;
              this.storage.store('examcountdown', minAvailable);
            }

          } else {
            //add remaining time
            var secondBetweenTwoDate = Math.abs((new Date(current_time).getTime() - new Date(startTimeStamp).getTime()) / 1000);
            let secondsAvailable = (parseInt(this.examInfo.duration) * 60) - Math.floor(secondBetweenTwoDate);
            let minAvailable = secondsAvailable / 60;
            this.storage.store('examcountdown', minAvailable);

          }
          this.remainingTimeCalculator();
        } else {
          this.storage.store('examcountdown', this.examInfo.duration);
          this.remainingTimeCalculator();
        }
      }, err => {
        this.storage.store('examcountdown', this.examInfo.duration);
        this.remainingTimeCalculator();
      });
    }
  }

  logoClicked(e: any) {
    // e.preventDefault();
    // e.stopPropagation();
    let userTypeId = this.userService.getUserType();
    let path = "/";
    if (this.isAuthenticated) {
      let product: any = userTypeId == 2 ? 'liveclass' : 'dashboard';
      path = `${dashboardRoute}${'/' + product || ''}`;
      if (this.current_route_url == "/dashboard/exampage") {
        return false;
      }
      else {
        if (this.is_exam_started && this.timer_header_for_routes.includes(this.current_route_url)) {
          path = dashboardRoute + "/exampage";
        }
      }
      navigateBetweenProjects(this.router, path);
    } else {
      window.location.href = homeRoute;
    }
  }

  saveRewardCoins() {
    isUserAdmin(this.userService).then((bool) => {
      if (bool) { return };
    })
    let totalNumberOfQuestionForTest = JSON.parse(localStorage.getItem('totalNumberOfQuestionForTest'));
    let notVisitedCount = JSON.parse(localStorage.getItem('totalUnAttemptedQuestion'));
    let attempted: any = Math.round(((Number(totalNumberOfQuestionForTest) - Number(notVisitedCount)) / totalNumberOfQuestionForTest) * 100);
    //? as we have a duplicate in question component line no: 865(approx) commenting this
    if (attempted >= 10 && attempted < 50) {
      // this.userService.saveRewardHistory(16).subscribe((res) => {
      //  }, err => this.spinner.hide());
    } else if (attempted >= 50) {
      // this.userService.saveRewardHistory(17).subscribe(res => { 
      // },
      //   err => this.spinner.hide());
    }
  }

  // addDailyGoal() {
  //   let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
  //   const data = {
  //     createDate: moment(new Date()).format('YYYY-MM-DD'),
  //     goalTime: JSON.parse(localStorage.getItem('setGoalTime')),
  //     spentTime: JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0,
  //     userId: userData?.userId
  //   }
  //   this.userService.addDailyGoals(data).subscribe((res: any) => {
  //   })
  // }

  ngOnDestroy(): void {
    if (this.eventSubscriber) {
      this.eventSubscriber.unsubscribe();
      this.eventSubscriber = null;
    }
    if (this.submitFeedbackPopsubscription) {
      this.submitFeedbackPopsubscription.unsubscribe();
    }
    if (this.examInfo_setting$) {
      this.examInfo_setting$?.unsubscribe()
    }
    if (this.examServiceTestegning$) {
      this.examServiceTestegning$?.unsubscribe()
    }
  }

  openFocusExamDialog() {
    const config: MatDialogConfig = {
      panelClass: ["UNFAPP-mweb-btmstiky-modal", "UNFAPP-gradeex-popup"],
      data: { msg: this.examName },
    };
    const dialogRef = this.dialog.open(FocusExamComponent, config);
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.displayExamName = res.name;
        this.selectedExam = res;
        let examName: any = res?.name?.replaceAll(' ', '')?.toUpperCase();
        this.examName = examName;
        localStorage.setItem('targetExamName', examName);
        // this.clickOnExam(this.displayExamName, 'liveclass');
        // this.getExamInfo();
        // this.loadAds();
        // this.updateSearchExamFilter();
        this.eventHandlingService.changeFocusedExamFromHeader.next({ examName: this.displayExamName })
        this.testListService.examNameChange.next(true)
      }
    })
  }

  // header logo tooltip
  logotooltip(type?: string, from?: string) {
    //  this.logotooltipstatus = !this.logotooltipstatus;
    let currentGrade = parseInt(this.user.grade.name)
    if(!this.router.url.includes('/subscription/mycart') && !this.router.url.includes('/subscription/proceed-to-payment')){
      if( (currentGrade==1 ||  currentGrade==2) && this.displayExamName.replaceAll(' ','').toUpperCase() =='APTITUDETEST'){
        this.router.navigate(['/dashboard/assessment']);
      }else if(this.router.url.includes('onboarding')){
        this.router.navigate(['/onboarding'])
      }else{
        this.router.navigate(['../'])
      }
    }
    if (type == 'stay' && localStorage.getItem('logo-popup')) {
      this.logotooltipstatus = !this.logotooltipstatus;
      from != 'logo' ? localStorage.setItem('stay-clicked', 'true') : ''
      window.onpopstate = function (e: any) { window.history.forward(); }
    } else if (type == 'home') {
      localStorage.removeItem('logo-popup');
      from != 'logo' ? localStorage.setItem('stay-clicked', 'true') : '';
      let url = JSON.parse(localStorage.getItem('current-subscr-url'));
      this.router.navigate([url]);
    }
  }



  updategoalDetails(logout) {
    let spentTime = JSON.parse(localStorage.getItem('setGoalSpendingTime')) || 0;
    let userData = JSON.parse(localStorage.getItem('user_details_from_server'));
    const data = {
      createDate: moment(new Date()).format('YYYY-MM-DD'),
      goalTime: JSON.parse(localStorage.getItem('setGoalTime')) || 0,
      spentTime: spentTime,
      userId: userData?.userId
    }
    this.userService.addDailyGoals(data).subscribe((res: any) => {
      if (res && logout) {
        this.sessionNotSession();
      }
    }, (err) => {
      if (err && err.status && err.status === 403) {
        this.sessionNotSession();
      }
    });
  }
  copyNumber() {
    this.showCopyOption = !this.showCopyOption;
    navigator.clipboard.writeText(callUssupportNumber);
  }

}
